import { replaceHrefsWithMediaUrl } from "utils/utils"

export function processRichTextWithImagePrefix(
  body: string,
  GRAPHQL_URL_CLIENT?: string,
) {
  const graphqlURL =
    process.env.GRAPHQL_URL ||
    GRAPHQL_URL_CLIENT ||
    "http://umbraco.shopily.co.il/graphql"
  const modifiedGraphQLURL = graphqlURL.replace(/\/graphql$/, "")
  const imageTagRegex = /<img[^>]+src="([^">]+)"/g
  const modifiedRichText = body.replace(imageTagRegex, (match, src) => {
    // Add the modified GraphQL URL prefix to the src
    const fullSrc = `${modifiedGraphQLURL}${src}`

    // Reconstruct the modified image tag
    return `<img src="${fullSrc}"`
  })
  const modifiedURLs = modifiedRichText.replaceAll("/pazcorp/pages", "")
  return replaceHrefsWithMediaUrl(modifiedURLs, GRAPHQL_URL_CLIENT)
}
